<template>
  <div id="app">
    <router-view></router-view> <!-- This is where routed components will be shown -->
  </div>
</template>

<script>


export default {
  name: 'App',

}
</script>
